import { AppState } from 'src/store'

// export const GetBaseUrl = (state: AppState) => {
//     return state.global.options.baseUrl
// }

export const GetDefault = (state: AppState) => {
    return state.query.list
}

export const SelectByKey = (key: string) => (state: AppState) => {
    return state.query.list;
}

export const SelectRequest = (state: AppState) => {
    return state.query.list.request;
}
